<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<!-- <Button type="primary" @click="add">新增</Button>
			<Button type="info" @click="cold">冷藏/常温</Button>
			<Button type="success" @click="start">启用/禁用</Button> -->
		</div>
		<div class="btn">
			<RadioGroup v-model="animal">
				<Radio label="列表"></Radio>
				<Radio label="地图"></Radio>
			</RadioGroup>
			<Button type="primary" shape="circle" @click="shuaxin">刷新设备状态</Button>
		</div>
		<div  class="lb" v-if="animal=='列表'">
			<div class="query">
				<div class="checkbox">
					<Select v-model="query.macKind" style="width:200px" @on-change="onchange" placeholder="设备分类">
					        <Option value="SHJ" >售货机</Option>
					        <Option value="KFJ" >咖啡机</Option>
					        <Option value="null" >不限</Option>
					</Select>
					<Select v-model="query.startUsing" style="width:200px" @on-change="onchange" placeholder="停用/启用">
					        <Option value="true" >启用</Option>
					        <Option value="false" >停用</Option>
					        <Option value="null" >不限</Option>
					</Select>
					<Select v-model="query.state" style="width:200px" @on-change="onchange" placeholder="正常/故障">
					        <Option value="true" >正常</Option>
					        <Option value="false" >故障</Option>
					        <Option value="null" >不限</Option>
					</Select>
					<Region @setRegion="setRegion"></Region>
				</div>
				<Input search enter-button placeholder="请输入地址/编号查询"  v-model="query.like" style="width: 500px;" @on-search="onsearch" />
			</div>
			<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
				<template slot-scope="{ row, index }" slot="action">
					<Button size="small" style="margin-right: 5px" @click="aisleList(row.id)" type="primary">货道信息</Button>
					<Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete">停用/启用</Button>
					<Button @click="guzhangListClick(row.id)" size="small" style="margin-right: 5px" class="delete">故障列表</Button>
					<Button @click="changName(row)" size="small" style="margin-right: 5px" class="delete" type="primary">修改设备名称</Button>
					<Modal v-model="modal2" width="360">
						<p slot="header" style="color:#f60;text-align:center">
							<Icon type="ios-information-circle"></Icon>
							<span>修改状态</span>
						</p>
						<div style="text-align:center">
							<p>确定修改？</p>
						</div>
						<div slot="footer">
							<Button type="error" size="large" long :loading="modal_loading" @click="remove()">确定</Button>
						</div>
					</Modal>
					<Modal v-model="isFlag" width="360">
						<div style="text-align:center">
							<p>设备名称：<input type="text" v-model="macName"  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false"></p>
						</div>
						<div slot="footer">
							<Button type="primary" size="large" long :loading="modal_loading" @click="changeConfire()">确定</Button>
						</div>
					</Modal>
				</template>
			</Table>
			<div class="my-page">
				<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>

		<div class="ditu" v-else>
			<ditu :zxd="zxd" :qt="qt"></ditu>
		</div>
		<Modal
        	v-model="isShow"
        	@on-ok="asyncOK" class="fontsize">
        	<p style="text-align: center;">故障原因:{{gzQuestion}}</p>
    	</Modal>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import ditu from '@/components/comm/ditu/ditu.vue'
	import Region from '@/components/comm/region1.vue'
	export default {
		data() {
			return {
				macName:'',
				isFlag:false,
				isShow:false,
				showPage:true,
				animal: '列表',
				//地图
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					/* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
				],
				//地图
				//查询条件
				wd: [],
				zt: [],
				gz: [],
				loading: false,
				total: 100,
				query: {
					page: 0,
					size: 10,
					id: '' ,//加盟商id
					like:'',
					macKind:'',
					regionId:'',
					startUsing:'',
					state:'',
				},
				columns12: [{
						title: '设备编号',
						key: 'id',
						width:90,
						align: 'center',
					},
					{
						title: '所属加盟商',
						key: 'alliance',
						width:100,
						align: 'center',
						render: (h, params) => {
								return h("div", params.row.alliance.companyName)
						}
					},
					{
						title: '分类',
						key: 'macKindstString',
						width:80,
						align: 'center',
					},
					{
						title: '名称',
						key: 'macName',
						width:80,
						align: 'center',
					},
					{
						title: '标识1',
						key: 'uuid1',
						width:80,
						align: 'center',
					},
					{
						title: '标识2',
						key: 'uuid2',
						width:80,
						align: 'center',
					},
					{
						title: '位置',
						key: 'address',
						width:80,
						align: 'center',
					},
					{
						title: '停用/启用',
						key: 'startUsing',
						width:90,
						align: 'center',
						render: (h, params) => {
							if (params.row.startUsing == true) {
								return h("div", "启用")
							} else {
								return h("div",{style:{color:'red'}},"停用")
							}
						}
					},
					{
						title: '是否故障',
						key: 'state',
						width:90,
						align: 'center',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "正常")
							} else {
								return h("div",{style:{color:'red',cursor:'pointer',borderBottom:'1px solid #888',margin:'0 auto',width:'24px'},on:{click:()=>{
									http.http({
										method: 'post',
										url: http.url + '/fac/mac/fault/details/newest',
										data: {
											id:params.row.id
										},
										success:(data)=>{
											if(data.code == 200) {
												this.gzQuestion = data.data
												this.isShow = true
											}
										}
									})
								}}},"故障")
							}
						}
					},
					{
						title: '状态',
						key: 'macContractStateString',
						width:80,
						align: 'center',
						render: (h, params) => {
							if (params.row.macContractStateName == 'WC') {
								return h("div", {style:{color:'green'}},params.row.macContractStateString)
							} else if(params.row.macContractStateName == 'YC') {
								return h("div",{style:{color:'red'}},params.row.macContractStateString)
							} else{
								return h("div",{style:{color:'blue'}},params.row.macContractStateString)
							}
						}
					},
					{
						title: '货道总数',
						key: 'total',
						width:90,
						align: 'center',
					},
					{
						title: '未分配数',
						key: 'isNull',
						width:90,
						align: 'center',
					},
					{
						title: '已分配数',
						key: 'isNotNull',
						width:90,
						align: 'center',
					},
					{
						title: '录入时间',
						key: 'createdTime',
						width:90,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 400,
						align: 'center'
					}
				],
				data6: [],
				deleteId: '',
				modal2: false,
				modal_loading: false,

			}
		},
		methods: {
			guzhangListClick(id){
				this.$router.push({
					name: 'jm/platform/gz/list',
					query: {
						id: id,//设备id
					}
				})
			},
			changName(row){
				this.macName = row.macName
				this.shebeiId = row.id
				this.isFlag = true
			},
			//修改设备名称
			changeConfire(){
				let _this=this
				http.http({
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/updateName',
				    data:{
						id:_this.shebeiId,
						macName:_this.macName
					},
					success: function(data) {
						if(data.code == 200) {
							_this.$Message.success('修改成功')
							_this.ajaxPage()
							_this.isFlag = false
						}
					}
				  })
			},
			shuaxin(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/refresh',
				    data:  {},
					_this:_this,
					success: function(data) {

					  	_this.ajaxPage()

					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			setRegion(regionId){

				if(regionId!=undefined && regionId!="不限"){
				    this.query.regionId=regionId
				    this.query.page=0

					//重新渲染子组件
					this.showPage = false
					this.$nextTick(() => {
						this.showPage = true
					})
					this.ajaxPage()
					this.ajaxPageDitu()
				}

			},
			onsearch(){
				let _this=this

				_this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
			},
			selectionChange(selections) { //选中项发生变化时就会触发

			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			remove(id) { //删除
			    let _this=this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/leave/factory/update/startusing',
					data: {id: _this.deleteId},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
					//假设后台需要的是表单数据这里你就可以更改
				  })

			},
			aisleList(id) { //设备货道信息
				this.$router.push({
					name: 'jm/platform/alliance/mac/aisle/list',
					query: {
						id: id,//设备id
						allianceId:this.query.id//加盟商id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			onchange(){
				this.query.page=0
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/allianceAll',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.loading = false
						_this.total = data.macLeaveFactorys.totalElements
						_this.data6 = data.macLeaveFactorys.content

					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			},
			ajaxPageDitu() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/allianceAll',
				    data:  {
						page: _this.query.page,
						size: 1000,
						id: _this.query.id ,//加盟商id
						like:_this.query.like,
						regionId:_this.query.regionId,
						macKind:'1'
					},
					_this: _this,
					success: function(data) {
						let a = data.macLeaveFactorys.content

						for (var i = 0; i < a.length; i++) {
							let latitude = parseFloat(a[i].latitude)
							let longitude = parseFloat(a[i].longitude)
							let b = {
								position: [longitude, latitude],
								id: a[i].id,
								url: '/main/jm/platform/allianceMacAisle/list',
								address: a[i].address,
								code: a[i].macCode,
							}
							_this.qt.push(b)
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			}

		},
		components: {
			page,ditu,Region
		},
		created() {
			this.ajaxPage()
			this.ajaxPageDitu()

		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
	/* .fontsize /deep/ .ivu-modal{
		.ivu-modal-footer{
			text-align: center !important;
		}
	} */
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/mac/list.vue